import React, { useContext } from 'react';
import { Mail } from 'lucide-react';
import { AutomationEditorContext } from '../../AutomationEditorContext';
import styles from '../SendMessageStep.module.css';

export const EmptyEmailPreview: React.FC = () => {
  const { editor } = useContext(AutomationEditorContext)!;

  return (
    <button type="button" className={styles.emptyState} onClick={editor.openStripo}>
      <Mail />
      <strong>Edit Email Template</strong>
      <span>Click to open the visual email designer</span>
    </button>
  );
};
